import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PageMetadataProvider } from '../context/PageMetadataContext';
import './App.css';
import Header from './Header';
import Footer from './Footer';
import HomePage from '../pages/HomePage';
import BioPage from '../pages/BioPage';
import ResearchPage from '../pages/ResearchPage';
import ProjectsPage from '../pages/ProjectsPage';
import PublicationsPage from '../pages/PublicationsPage';
import TeachingPage from '../pages/TeachingPage';
import EventsPage from '../pages/EventsPage';
import SportPage from '../pages/SportPage';
import StaticFallback from './StaticFallback';
import InetAnalyticsPage from '../pages/projects/InetAnalyticsPage';
import PlanetLabPage from '../pages/projects/PlanetLabPage';
import MercuryPage from '../pages/projects/MercuryPage';
import YtCrawlerRelease1Page from '../pages/projects/YtCrawlerRelease1Page';
import YtCrawlerRelease2Page from '../pages/projects/YtCrawlerRelease2Page';
import YtAnalyticsPage from '../pages/projects/YtAnalyticsPage';
import SimWorkerPage from '../pages/projects/SimWorkerPage';
import SimStreamPage from '../pages/projects/SimStreamPage';
import PhdPage from '../pages/research/PhdPage';
import PhdPresentationPage from '../pages/research/PhdPresentationPage';
import PhdDissertationPage from '../pages/research/PhdDissertationPage';
import PhdMapPage from '../pages/research/PhdMapPage';
import LatexInMatlabTicksPage from '../pages/research/LatexInMatlabTicksPage';
import AdvancedMatlabBoxplotPage from '../pages/research/AdvancedMatlabBoxplotPage';

const App = () => {
  return (
    <PageMetadataProvider>
      <Router>
        <div className="app">
          {/* Skip to content link for accessibility */}
          <a href="#main-content" className="skip-link">
            Skip to main content
          </a>
          <Header />
          <main id="main-content" className="main">
            <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/bio" element={<BioPage />} />
        <Route path="/research" element={<ResearchPage />} />
        <Route path="/research.html" element={<Navigate to="/research" replace />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects.html" element={<Navigate to="/projects" replace />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/pubs.html" element={<Navigate to="/publications" replace />} />
        <Route path="/pubs" element={<Navigate to="/publications" replace />} />
        <Route path="/teaching" element={<TeachingPage />} />
        <Route path="/teaching.html" element={<Navigate to="/teaching" replace />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events.html" element={<Navigate to="/events" replace />} />
        <Route path="/bio/sport" element={<SportPage />} />
        <Route path="/bio/sport.html" element={<Navigate to="/bio/sport" replace />} />
        <Route path="/projects/inetanalytics" element={<InetAnalyticsPage />} />
        <Route path="/projects/inetanalytics/planetlab" element={<PlanetLabPage />} />
        <Route path="/projects/inetanalytics/mercury" element={<MercuryPage />} />
        <Route path="/projects/ytcrawler/release1" element={<YtCrawlerRelease1Page />} />
        <Route path="/projects/ytcrawler/release2" element={<YtCrawlerRelease2Page />} />
        <Route path="/projects/ytanalytics" element={<YtAnalyticsPage />} />
        <Route path="/projects/simworker" element={<SimWorkerPage />} />
        <Route path="/projects/simstream" element={<SimStreamPage />} />
        <Route path="/research/phd" element={<PhdPage />} />
        <Route path="/research/phd/presentation" element={<PhdPresentationPage />} />
        <Route path="/research/phd/dissertation" element={<PhdDissertationPage />} />
        <Route path="/research/phd/map" element={<PhdMapPage />} />
        <Route path="/research/latex_in_matlab_ticks" element={<LatexInMatlabTicksPage />} />
        <Route path="/research/advanced_matlab_boxplot" element={<AdvancedMatlabBoxplotPage />} />
        <Route path="/projects/inetanalytics/index.html" element={<Navigate to="/projects/inetanalytics" replace />} />
        <Route path="/projects/inetanalytics/planetlab/index.html" element={<Navigate to="/projects/inetanalytics/planetlab" replace />} />
        <Route path="/projects/inetanalytics/mercury/index.html" element={<Navigate to="/projects/inetanalytics/mercury" replace />} />
        <Route path="/projects/ytcrawler/release1.html" element={<Navigate to="/projects/ytcrawler/release1" replace />} />
        <Route path="/projects/ytcrawler/release2.html" element={<Navigate to="/projects/ytcrawler/release2" replace />} />
        <Route path="/projects/ytanalytics/index.html" element={<Navigate to="/projects/ytanalytics" replace />} />
        <Route path="/projects/simworker/index.html" element={<Navigate to="/projects/simworker" replace />} />
        <Route path="/projects/simstream/index.html" element={<Navigate to="/projects/simstream" replace />} />
        <Route path="/research/phd/index.html" element={<Navigate to="/research/phd" replace />} />
        <Route path="/research/phd/presentation/index.html" element={<Navigate to="/research/phd/presentation" replace />} />
        <Route path="/research/phd/dissertation/index.html" element={<Navigate to="/research/phd/dissertation" replace />} />
        <Route path="/research/phd/map/index.html" element={<Navigate to="/research/phd/map" replace />} />
        <Route path="/research/latex_in_matlab_ticks/index.html" element={<Navigate to="/research/latex_in_matlab_ticks" replace />} />
        <Route path="/research/advanced_matlab_boxplot/index.html" element={<Navigate to="/research/advanced_matlab_boxplot" replace />} />
        <Route path="/contact" element={<Navigate to="/" replace />} />
        <Route path="/contact.html" element={<Navigate to="/" replace />} />
        <Route path="/accessibility" element={<Navigate to="/" replace />} />
        <Route path="/accessibility.html" element={<Navigate to="/" replace />} />
        <Route path="/copyright" element={<Navigate to="/" replace />} />
        <Route path="/copyright.html" element={<Navigate to="/" replace />} />
        {/* Catch-all route: fallback to static HTML files for unmatched routes */}
            <Route path="*" element={<StaticFallback />} />
          </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </PageMetadataProvider>
  );
};

export default App;

